var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { GFIDProvider, HealthcareOrganizationDto, HealthcareOrganizationPatientFacingDto } from "./healthcareorganization.dtos";
import { HealthcareOrganizationUserDto } from "./healthcareorganizationuser.dtos";
import { ExternalResearcherOrganizationDto, ExternalResearcherOrganizationPublicProfileDto } from "./externalresearcherorganization.dtos";
import { ExternalResearcherUserDto } from "./externalresearcherorganizationuser.dtos";
import { PatientDto, ProxyAccessDto } from "./patient.dtos";
import { ServiceProviderOrganizationDto } from "./serviceproviderorganization.dtos";
import { ServiceProviderUserDto } from "./serviceprovideruser.dtos";
import { IsEnum, IsOptional, IsString, IsDate, ValidateNested, IsNumber, IsArray, IsBoolean, IsNotEmpty } from "class-validator";
import { UserPermissions, UserType } from "./user.dtos";
import { Type } from "class-transformer";
import { PortalUserFullInfoDto } from "./blockchain.dtos";
import { BaseOrganizationDto } from "./organization.dtos";
import { ApiProperty, OmitType, PickType } from "@nestjs/swagger";
export var SystemType;
(function (SystemType) {
    SystemType["CLOUD_BACKEND"] = "CLOUD_BACKEND";
    SystemType["AGENT"] = "AGENT";
    SystemType["AGENT_DEPLOY"] = "AGENT_DEPLOY";
})(SystemType || (SystemType = {}));
export var AuthType;
(function (AuthType) {
    AuthType["USERNAME_PASSWORD"] = "USERNAME_PASSWORD";
    AuthType["SSO_SAML"] = "SSO_SAML";
})(AuthType || (AuthType = {}));
export class AuthTypeResponse {
}
__decorate([
    IsEnum(AuthType),
    __metadata("design:type", String)
], AuthTypeResponse.prototype, "authType", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], AuthTypeResponse.prototype, "redirectUrl", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], AuthTypeResponse.prototype, "provider", void 0);
export var SystemPermissions;
(function (SystemPermissions) {
    SystemPermissions["QUERY"] = "QUERY";
    SystemPermissions["UPDATE"] = "UPDATE";
})(SystemPermissions || (SystemPermissions = {}));
export var ApiClientType;
(function (ApiClientType) {
    ApiClientType["API_HEALTHCARE_ORGANIZATION"] = "API_DATA_ORIGINATOR";
    ApiClientType["API_EXTERNAL_RESEARCHER"] = "API_EXTERNAL_RESEARCHER";
    ApiClientType["API_SERVICE_PROVIDER"] = "API_SERVICE_PROVIDER";
})(ApiClientType || (ApiClientType = {}));
export var OnChainPermissions;
(function (OnChainPermissions) {
    OnChainPermissions["ON_CHAIN_ACTIONS"] = "ON_CHAIN_ACTIONS";
})(OnChainPermissions || (OnChainPermissions = {}));
export class AuthenticatedTokenHealthcareOrganization {
    constructor() {
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedTokenHealthcareOrganization.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedTokenHealthcareOrganization.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedTokenHealthcareOrganization.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedTokenHealthcareOrganization.prototype, "mrn", void 0);
export class AuthenticatedTokenExternalResearchOrganization {
    constructor() {
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedTokenExternalResearchOrganization.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedTokenExternalResearchOrganization.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedTokenExternalResearchOrganization.prototype, "organizationId", void 0);
export function authenticatedUserOrganizationIds(user) {
    if (user.type === UserType.PATIENT) {
        return user.authenticatedOrganizations.map((org) => org.organizationId);
    }
    else if (user.type === SystemType.AGENT_DEPLOY || user.type === SystemType.CLOUD_BACKEND) {
        return [];
    }
    else {
        return [user.organizationId];
    }
}
export function authenticatedUserInOrganization(user, organizationId) {
    return authenticatedUserOrganizationIds(user).some((candidateId) => {
        return candidateId === organizationId;
    });
}
export function getMatchingPatientAuthenticatedOrganization(user, patientId, organizationId) {
    var _a;
    if (user.type === UserType.PATIENT) {
        return ((_a = user.authenticatedOrganizations.find((healthcareOrganization) => {
            return healthcareOrganization.organizationId === organizationId && healthcareOrganization.userId === patientId;
        })) !== null && _a !== void 0 ? _a : null);
    }
    else {
        return null;
    }
}
export function authenticatedUserMatchPatientAndOrganization(user, patientId, organizationId, options) {
    if (user.type === UserType.PATIENT) {
        return !!getMatchingPatientAuthenticatedOrganization(user, patientId, organizationId);
    }
    else {
        return !!(options === null || options === void 0 ? void 0 : options.allowProvider) && user.permissions.includes(UserPermissions.PROVIDER) && user.organizationId === organizationId;
    }
}
export class AssociatedPatient {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AssociatedPatient.prototype, "mrn", void 0);
export class AuthenticatedHealthcareOrganizationUserWithDetails extends HealthcareOrganizationUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    Type(() => HealthcareOrganizationDto),
    ValidateNested(),
    __metadata("design:type", HealthcareOrganizationDto)
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "organization", void 0);
__decorate([
    Type(() => PortalUserFullInfoDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", PortalUserFullInfoDto)
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "portalClient", void 0);
__decorate([
    Type(() => AssociatedPatient),
    IsOptional(),
    __metadata("design:type", AssociatedPatient)
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "associatedPatient", void 0);
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedHealthcareOrganizationUserWithDetails.prototype, "type", void 0);
export class AuthenticatedExternalResearcherUserWithDetails extends ExternalResearcherUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    Type(() => ExternalResearcherOrganizationDto),
    ValidateNested(),
    __metadata("design:type", ExternalResearcherOrganizationDto)
], AuthenticatedExternalResearcherUserWithDetails.prototype, "organization", void 0);
__decorate([
    Type(() => PortalUserFullInfoDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", PortalUserFullInfoDto)
], AuthenticatedExternalResearcherUserWithDetails.prototype, "portalClient", void 0);
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedExternalResearcherUserWithDetails.prototype, "type", void 0);
export class AuthenticatedProviderFromAgent extends PickType(HealthcareOrganizationUserDto, ["firstName", "lastName", "email"]) {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedProviderFromAgent.prototype, "providerId", void 0);
export class AuthenticatedProviderContextFromAgent {
}
__decorate([
    Type(() => AuthenticatedProviderFromAgent),
    ValidateNested(),
    __metadata("design:type", AuthenticatedProviderFromAgent)
], AuthenticatedProviderContextFromAgent.prototype, "provider", void 0);
__decorate([
    Type(() => AuthenticatedPatientFromAgentWithDetails),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", AssociatedPatient)
], AuthenticatedProviderContextFromAgent.prototype, "associatedPatient", void 0);
export class AuthenticatedServiceProviderUserWithDetails extends ServiceProviderUserDto {
    constructor() {
        super(...arguments);
        this.type = UserType.SERVICE_PROVIDER;
    }
}
__decorate([
    Type(() => ServiceProviderOrganizationDto),
    ValidateNested(),
    __metadata("design:type", ServiceProviderOrganizationDto)
], AuthenticatedServiceProviderUserWithDetails.prototype, "organization", void 0);
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedServiceProviderUserWithDetails.prototype, "type", void 0);
export class AuthenticatedPatientDto extends OmitType(PatientDto, ["organizationId", "mrn"]) {
    constructor() {
        super(...arguments);
        this.type = UserType.PATIENT;
    }
}
__decorate([
    IsEnum(GFIDProvider),
    IsOptional(),
    __metadata("design:type", String)
], AuthenticatedPatientDto.prototype, "gfidProvider", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ProxyAccessDto)
], AuthenticatedPatientDto.prototype, "proxyAccess", void 0);
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedPatientDto.prototype, "type", void 0);
export class AuthenticatedHealthcareOrganizationWithDetails extends HealthcareOrganizationPatientFacingDto {
    constructor() {
        super(...arguments);
        this.type = UserType.HEALTHCARE_ORGANIZATION;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationWithDetails.prototype, "mrn", void 0);
export class AuthenticatedExternalResearcherOrganizationWithDetails extends ExternalResearcherOrganizationPublicProfileDto {
    constructor() {
        super(...arguments);
        this.type = UserType.EXTERNAL_RESEARCHER;
    }
}
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedExternalResearcherOrganizationWithDetails.prototype, "organizationId", void 0);
export class AuthenticatedPatientWithDetails extends AuthenticatedPatientDto {
}
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AuthenticatedPatientWithDetails.prototype, "authenticatedWithIAL2", void 0);
__decorate([
    IsArray(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: AuthenticatedHealthcareOrganizationWithDetails, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: AuthenticatedExternalResearcherOrganizationWithDetails, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested({ each: true }),
    __metadata("design:type", Array)
], AuthenticatedPatientWithDetails.prototype, "organizations", void 0);
export class AuthenticatedHealthcareOrganizationFromAgent {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationFromAgent.prototype, "userId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationFromAgent.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedHealthcareOrganizationFromAgent.prototype, "mrn", void 0);
__decorate([
    Type(() => HealthcareOrganizationDto),
    ValidateNested(),
    __metadata("design:type", Object)
], AuthenticatedHealthcareOrganizationFromAgent.prototype, "organization", void 0);
export class AuthenticatedPatientFromAgentWithDetails extends AuthenticatedPatientDto {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthenticatedPatientFromAgentWithDetails.prototype, "language", void 0);
__decorate([
    Type(() => AuthenticatedHealthcareOrganizationFromAgent),
    ValidateNested(),
    __metadata("design:type", AuthenticatedHealthcareOrganizationFromAgent)
], AuthenticatedPatientFromAgentWithDetails.prototype, "organization", void 0);
export class AuthenticationByPatientIdInput {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByPatientIdInput.prototype, "patientId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthenticationByPatientIdInput.prototype, "organizationName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthenticationByPatientIdInput.prototype, "organizationId", void 0);
export class AuthenticatedScreenshotUserWithDetails {
    constructor() {
        this.type = UserType.SCREENSHOT_USER;
    }
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedScreenshotUserWithDetails.prototype, "id", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedScreenshotUserWithDetails.prototype, "firstName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedScreenshotUserWithDetails.prototype, "lastName", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedScreenshotUserWithDetails.prototype, "organizationId", void 0);
__decorate([
    Type(() => BaseOrganizationDto, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: HealthcareOrganizationDto, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: ExternalResearcherOrganizationDto, name: UserType.EXTERNAL_RESEARCHER },
                { value: ServiceProviderOrganizationDto, name: UserType.SERVICE_PROVIDER },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], AuthenticatedScreenshotUserWithDetails.prototype, "organization", void 0);
__decorate([
    IsEnum(UserType),
    __metadata("design:type", Object)
], AuthenticatedScreenshotUserWithDetails.prototype, "type", void 0);
export class AuthenticatedAPIClient {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedAPIClient.prototype, "apiKeyId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticatedAPIClient.prototype, "organizationId", void 0);
__decorate([
    IsEnum(ApiClientType),
    __metadata("design:type", String)
], AuthenticatedAPIClient.prototype, "type", void 0);
__decorate([
    IsEnum(UserPermissions, { each: true }),
    __metadata("design:type", Array)
], AuthenticatedAPIClient.prototype, "permissions", void 0);
export class CreateUserInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "password", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "phone", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "name", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateUserInput.prototype, "title", void 0);
__decorate([
    IsEnum(UserPermissions, { each: true }),
    __metadata("design:type", Array)
], CreateUserInput.prototype, "permissions", void 0);
export class ForgotPasswordInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ForgotPasswordInput.prototype, "email", void 0);
export class ResetPasswordInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ResetPasswordInput.prototype, "password", void 0);
export class ChangePasswordInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], ChangePasswordInput.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ChangePasswordInput.prototype, "currentPassword", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], ChangePasswordInput.prototype, "password", void 0);
export var AuthTypeCheckInputType;
(function (AuthTypeCheckInputType) {
    AuthTypeCheckInputType["EMAIL"] = "EMAIL";
    AuthTypeCheckInputType["ORGANIZATION"] = "ORGANIZATION";
})(AuthTypeCheckInputType || (AuthTypeCheckInputType = {}));
export class AuthTypeCheckByEmailInput {
    constructor() {
        this.type = AuthTypeCheckInputType.EMAIL;
    }
}
__decorate([
    IsEnum(AuthTypeCheckInputType),
    __metadata("design:type", Object)
], AuthTypeCheckByEmailInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthTypeCheckByEmailInput.prototype, "email", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTypeCheckByEmailInput.prototype, "redirectURL", void 0);
export class AuthTypeCheckByOrganizationInput {
    constructor() {
        this.type = AuthTypeCheckInputType.ORGANIZATION;
    }
}
__decorate([
    IsEnum(AuthTypeCheckInputType),
    __metadata("design:type", Object)
], AuthTypeCheckByOrganizationInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthTypeCheckByOrganizationInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTypeCheckByOrganizationInput.prototype, "redirectURL", void 0);
export var AuthenticationInputType;
(function (AuthenticationInputType) {
    AuthenticationInputType["PASSWORD"] = "PASSWORD";
    AuthenticationInputType["SMART"] = "SMART";
    AuthenticationInputType["CLEAR_IAL2"] = "CLEAR_IAL2";
    AuthenticationInputType["EXISTING_TOKEN"] = "EXISTING_TOKEN";
})(AuthenticationInputType || (AuthenticationInputType = {}));
export class AuthenticationByPasswordInput {
    constructor() {
        this.type = AuthenticationInputType.PASSWORD;
    }
}
__decorate([
    IsEnum(AuthenticationInputType),
    __metadata("design:type", Object)
], AuthenticationByPasswordInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByPasswordInput.prototype, "email", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByPasswordInput.prototype, "password", void 0);
export class AuthenticationBySMARTOnFHIRInput {
    constructor() {
        this.type = AuthenticationInputType.SMART;
    }
}
__decorate([
    IsEnum(AuthenticationInputType),
    __metadata("design:type", Object)
], AuthenticationBySMARTOnFHIRInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationBySMARTOnFHIRInput.prototype, "smartCode", void 0);
__decorate([
    IsString(),
    IsEnum(UserType),
    __metadata("design:type", String)
], AuthenticationBySMARTOnFHIRInput.prototype, "userType", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationBySMARTOnFHIRInput.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationBySMARTOnFHIRInput.prototype, "redirectUri", void 0);
export class AuthenticationByCLEARIAL2Input {
    constructor() {
        this.type = AuthenticationInputType.CLEAR_IAL2;
    }
}
__decorate([
    IsEnum(AuthenticationInputType),
    __metadata("design:type", Object)
], AuthenticationByCLEARIAL2Input.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByCLEARIAL2Input.prototype, "authCode", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByCLEARIAL2Input.prototype, "redirectUri", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthenticationByCLEARIAL2Input.prototype, "organizationId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AuthenticationByCLEARIAL2Input.prototype, "checkAll", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AuthenticationByCLEARIAL2Input.prototype, "useFallback", void 0);
export class RefreshByCLEARIAL2Input {
    constructor() {
        this.type = AuthenticationInputType.CLEAR_IAL2;
    }
}
__decorate([
    IsEnum(AuthenticationInputType),
    __metadata("design:type", Object)
], RefreshByCLEARIAL2Input.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], RefreshByCLEARIAL2Input.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], RefreshByCLEARIAL2Input.prototype, "patientId", void 0);
export class TokenInputForTesting {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], TokenInputForTesting.prototype, "patientId", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], TokenInputForTesting.prototype, "organizationId", void 0);
export class PatientDemographicsAddress {
}
__decorate([
    IsArray(),
    IsOptional(),
    __metadata("design:type", Array)
], PatientDemographicsAddress.prototype, "lines", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDemographicsAddress.prototype, "city", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDemographicsAddress.prototype, "district", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDemographicsAddress.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDemographicsAddress.prototype, "postalCode", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PatientDemographicsAddress.prototype, "country", void 0);
export class PatientDemographics {
}
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PatientDemographics.prototype, "familyName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PatientDemographics.prototype, "givenName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PatientDemographics.prototype, "birthDate", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PatientDemographics.prototype, "phone", void 0);
__decorate([
    IsString(),
    IsOptional(),
    IsNotEmpty(),
    __metadata("design:type", String)
], PatientDemographics.prototype, "email", void 0);
__decorate([
    Type(() => PatientDemographicsAddress),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", PatientDemographicsAddress)
], PatientDemographics.prototype, "address", void 0);
export class AuthenticationByGFIDInput {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByGFIDInput.prototype, "gfid", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider),
    __metadata("design:type", String)
], AuthenticationByGFIDInput.prototype, "gfidProvider", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByGFIDInput.prototype, "organizationId", void 0);
__decorate([
    Type(() => PatientDemographics),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", PatientDemographics)
], AuthenticationByGFIDInput.prototype, "demographics", void 0);
export class AuthenticationByExistingTokenInput {
    constructor() {
        this.type = AuthenticationInputType.EXISTING_TOKEN;
    }
}
__decorate([
    IsEnum(AuthenticationInputType),
    __metadata("design:type", Object)
], AuthenticationByExistingTokenInput.prototype, "type", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], AuthenticationByExistingTokenInput.prototype, "token", void 0);
export class AuthenticationByAPIKeyAndSecret {
}
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], AuthenticationByAPIKeyAndSecret.prototype, "apiKey", void 0);
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], AuthenticationByAPIKeyAndSecret.prototype, "apiSecret", void 0);
export class GenerateUserTokenResult {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], GenerateUserTokenResult.prototype, "token", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], GenerateUserTokenResult.prototype, "expiration", void 0);
__decorate([
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: AuthenticatedHealthcareOrganizationUserWithDetails, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: AuthenticatedExternalResearcherUserWithDetails, name: UserType.EXTERNAL_RESEARCHER },
                { value: AuthenticatedServiceProviderUserWithDetails, name: UserType.SERVICE_PROVIDER },
                { value: AuthenticatedPatientWithDetails, name: UserType.PATIENT },
                { value: AuthenticatedScreenshotUserWithDetails, name: UserType.SCREENSHOT_USER },
            ],
        },
    }),
    ValidateNested(),
    __metadata("design:type", Object)
], GenerateUserTokenResult.prototype, "user", void 0);
export class GenerateSystemTokenResult {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], GenerateSystemTokenResult.prototype, "token", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], GenerateSystemTokenResult.prototype, "expiration", void 0);
export class GenerateAPITokenResult {
}
__decorate([
    ApiProperty(),
    IsString(),
    __metadata("design:type", String)
], GenerateAPITokenResult.prototype, "token", void 0);
__decorate([
    ApiProperty(),
    IsNumber(),
    __metadata("design:type", Number)
], GenerateAPITokenResult.prototype, "expiration", void 0);
export class BaseTokenPayload {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "iss", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "sub", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "aud", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], BaseTokenPayload.prototype, "iat", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], BaseTokenPayload.prototype, "exp", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "jti", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Number)
], BaseTokenPayload.prototype, "extendableExpiration", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], BaseTokenPayload.prototype, "applicationId", void 0);
export class AuthTokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId"]) {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "email", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(UserPermissions, { each: true }),
    __metadata("design:type", Array)
], AuthTokenPayload.prototype, "permissions", void 0);
__decorate([
    IsString(),
    IsEnum(UserType),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "state", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "firstName", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "lastName", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional(),
    __metadata("design:type", Date)
], AuthTokenPayload.prototype, "createdAt", void 0);
__decorate([
    IsString(),
    IsEnum(GFIDProvider),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "gfidProvider", void 0);
__decorate([
    Type(() => ProxyAccessDto),
    ValidateNested(),
    IsOptional(),
    __metadata("design:type", ProxyAccessDto)
], AuthTokenPayload.prototype, "proxyAccess", void 0);
__decorate([
    IsArray(),
    Type(() => Object, {
        discriminator: {
            property: "type",
            subTypes: [
                { value: AuthenticatedTokenHealthcareOrganization, name: UserType.HEALTHCARE_ORGANIZATION },
                { value: AuthenticatedTokenExternalResearchOrganization, name: UserType.EXTERNAL_RESEARCHER },
            ],
        },
    }),
    ValidateNested({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], AuthTokenPayload.prototype, "authenticatedOrganizations", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], AuthTokenPayload.prototype, "projectId", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], AuthTokenPayload.prototype, "authenticatedWithIAL2", void 0);
export class APITokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId"]) {
}
__decorate([
    IsString(),
    __metadata("design:type", String)
], APITokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsEnum(ApiClientType),
    __metadata("design:type", String)
], APITokenPayload.prototype, "type", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(UserPermissions, { each: true }),
    __metadata("design:type", Array)
], APITokenPayload.prototype, "permissions", void 0);
export class SystemAuthTokenPayload extends OmitType(BaseTokenPayload, ["type", "organizationId", "applicationId"]) {
}
__decorate([
    IsEnum(SystemPermissions, { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], SystemAuthTokenPayload.prototype, "permissions", void 0);
__decorate([
    IsString({ each: true }),
    IsEnum(SystemType, { each: true }),
    __metadata("design:type", String)
], SystemAuthTokenPayload.prototype, "type", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SystemAuthTokenPayload.prototype, "organizationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SystemAuthTokenPayload.prototype, "applicationId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], SystemAuthTokenPayload.prototype, "version", void 0);
export class PublicKey {
}
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "kid", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "kty", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "e", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "use", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "alg", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], PublicKey.prototype, "n", void 0);
